// extracted by mini-css-extract-plugin
export default {"modalContent":"_Modal_modalContent__Tbbhh"};